import { render, staticRenderFns } from "./DeliverablesList.view.vue?vue&type=template&id=60aac1a2&"
import script from "./DeliverablesList.view.vue?vue&type=script&lang=js&"
export * from "./DeliverablesList.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60aac1a2')) {
      api.createRecord('60aac1a2', component.options)
    } else {
      api.reload('60aac1a2', component.options)
    }
    module.hot.accept("./DeliverablesList.view.vue?vue&type=template&id=60aac1a2&", function () {
      api.rerender('60aac1a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/common/partials/deliverables/view/DeliverablesList.view.vue"
export default component.exports